import React from "react";
import { Col, Container, Row } from "reactstrap";
import { useRef, useState } from "react";
import ProtectionImage from "../../Assets/Images/protection-image.jpg";
import CashValueImage from "../../Assets/Images/cash-value-image.jpg";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";
import Protection from "./Protection";
import CashValue from "./CashValue";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const componentMap = {
  PROTECTION: <Protection isScrollable={true} />,
  CASHVALUE: <CashValue isScrollable={true} />,
};
const ProtectionPlusPolicyTab = ({ sectionRef }) => {
  const translations = useTranslation(); // Get translations dynamically
  useAnimateOnScroll();

  const [change, setChange] = useState("PROTECTION");

  return (
    <div
      id="Benefits"
      ref={sectionRef}
      className="supeior-rating py-12 lg:pb-36 mb-0 md:pb-12 md:pt-[8rem] min-h-[100vh]"
    >
      <div className="tab-capsule-img-box relative lg:absolute w-[100%] lg:w-[50%] pl-[20px] right-0 lg:block hidden universalBenifits-image">
        <div className="tab-capsule-inner-box flex-1 w-[100%] flex-none !ml-auto ms-[5%] mt-[5%] md:mt-0 order-first lg:order-last">
          <div className="circle-div ml-[20px] lg:ml-0 mb-[10%] md:mb-0 max-h-[688px] animate__animated animate__fadeInRight">
            <img
              src={change === "PROTECTION" ? ProtectionImage : CashValueImage}
              width={"100%"}
              className="object-cover "
              alt="not found"
            />
          </div>
        </div>
      </div>
      <Container>
        <div className="">
          <div className=" animate__animated  mt-0 lg:mt-28 animate__fadeInLeft max-w-[460px] lg:pl-0 pl-4">
            <div class="text-[16px] font-normal mb-4 lg:block hidden">
              {translations.universeProduct_subtitle}
            </div>
            <h2
              className="lg:text-[2.5rem] lg:leading-[2.8rem] text-[24px] leading-[28px] lg:mb-8 lg:font-normal font-semibold"
              dangerouslySetInnerHTML={{
                __html: translations.universeProduct_heading,
              }}
            ></h2>
            <div className="active-section flex lg:justify-center justify-space-between gap-2 bg-white rounded-full mt-4 mb-4 max-w-[260px]">
              <button
                onClick={() => setChange("PROTECTION")}
                className={`flex-1 content ${
                  change === "PROTECTION" ? "active bg-[#0D4248]" : ""
                } font-medium  ${
                  change === "PROTECTION" ? "text-white" : "text-black"
                } py-3 px-4 rounded-full w-1/3`}
              >
                {translations.universeProtection_tab}
              </button>
              <button
                onClick={() => setChange("CASHVALUE")}
                className={`flex-1 content ${
                  change === "CASHVALUE" ? "active bg-[#0D4248]" : ""
                } font-medium  ${
                  change === "CASHVALUE" ? "text-white" : "text-black"
                } py-3 px-4 rounded-full w-1/3`}
              >
                {translations.universeCashValue_tab}
              </button>
            </div>
          </div>
          {componentMap[change] || null}
        </div>
      </Container>
    </div>
  );
};

export default ProtectionPlusPolicyTab;
